module.exports = __webpack_public_path__ + "img/VAMPIRO.cd719bbc.jpg";